module.exports = __webpack_public_path__ + "img/智能管网自动化管理系统V1.0.acfad46d.jpg";